import { render, staticRenderFns } from "./ProductDetailSubmenu.vue?vue&type=template&id=2a4cba11"
import script from "./ProductDetailSubmenu.vue?vue&type=script&lang=js"
export * from "./ProductDetailSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports